import { Component, inject } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmlistdialog',
  standalone: false,
  templateUrl: './confirmlistdialog.component.html',
  styleUrl: './confirmlistdialog.component.css'
})
export class ConfirmListDialogComponent {
  dialogRef = inject<MatDialogRef<ConfirmListDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private db = inject(AngularFirestore);


  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
